<ng-template cxOutlet="cx-storefront" cxPageTemplateStyle>
  <ng-template cxOutlet="cx-header">
    <header
      id="header-nav"
      cxSkipLink="cx-header"
      [cxFocus]="{ disableMouseFocus: true }"
      [class.is-expanded]="isExpanded$ | async"
      (keydown.escape)="collapseMenu()"
      (click)="collapseMenuIfClickOutside($event)"
    >
      <div class="wrapper-header">
        <cx-page-layout section="header"></cx-page-layout>
      </div>
      <div class="wrapper-head-band">
        <cx-page-layout section="headBand"></cx-page-layout>
      </div>
      <div id="wrapper-navigation">
        <div class="wrapper-navigation-container">
          <cx-page-layout section="navigation"></cx-page-layout>
          <cx-page-layout section="rightPart"></cx-page-layout>
        </div>

      </div>
    </header>
    <cx-page-slot position="BottomHeaderSlot"></cx-page-slot>
    <cx-global-message></cx-global-message>
  </ng-template>

  <main cxSkipLink="cx-main" [cxFocus]="{ disableMouseFocus: true }">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </main>

  <ng-template cxOutlet="cx-footer">
    <footer cxSkipLink="cx-footer" [cxFocus]="{ disableMouseFocus: true }">
      <cx-page-layout section="footer"></cx-page-layout>
    </footer>
  </ng-template>
  <recaptcha></recaptcha>
</ng-template>
